module.exports = __webpack_public_path__ + "media/images/pc/page_common/logo/logo_decollte-2678ac2d7f8d178f05ad88f79e311cb9.svg";